import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API_URL } from "config";
import { Accessory } from "features/accessories/types";
import { RootState } from "store/rootReducer";
import { AccessoryDetailsState } from "./types";
import Axios from "axios";

let initialState: AccessoryDetailsState = {
  fetchedAccessory: null,
  isLoading: false,
  hasError: false,
};

const accessoryDetails = createSlice({
  name: "accessoryDetails",
  initialState,
  reducers: {
    setFetchedAccessory(state, action: PayloadAction<Accessory | null>) {
      state.fetchedAccessory = action.payload;
      state.isLoading = false;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setHasError(state, action: PayloadAction<boolean>) {
      state.hasError = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setFetchedAccessory,
  setIsLoading,
  setHasError,
} = accessoryDetails.actions;

export const selectFetchedAccessory = (state: RootState) =>
  state.accessoryDetails.fetchedAccessory;
export const selectAccessoryDetailsLoading = (state: RootState) =>
  state.accessoryDetails.isLoading;
export const selectAccessoryDetailsHasError = (state: RootState) =>
  state.accessoryDetails.hasError;

export const fetchAccessoryById = (id: string) => async (dispatch: any) => {
  dispatch(setIsLoading(true));
  try {
    const response = await Axios.get(`${API_URL}/accessories/${id}`);
    dispatch(setFetchedAccessory(response.data.data));
  } catch (error: any) {
    dispatch(setHasError(true));
  }
};

export default accessoryDetails.reducer;
